import React, { Fragment } from "react";

import img13 from "../../../images/service/Initial Game Offering/1.png";
import img14 from "../../../images/service/Initial Game Offering/2.png";

import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import Benefit from "../../../components/PageSection/BenefitSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import HeroSection from "../../../components/PageSection/HeroSection";
import TheorySection from "../../../components/PageSection/Theory";

// ------------------------------------
// DATA
// ------------------------------------

const serviceCards = [
  {
    icon: sIcon1,
    title: "IGO Platform Development",
    content:
      "End-to-end development of Initial Game Offering platforms with secure launchpad architecture and investor-ready features.",
  },
  {
    icon: sIcon2,
    title: "Tokenomics & Smart Contracts",
    content:
      "Design and deployment of game token smart contracts with vesting, staking, and controlled distribution mechanisms.",
  },
  {
    icon: sIcon3,
    title: "GameFi Launch Strategy",
    content:
      "Strategic planning for fundraising, user onboarding, and community-driven token launches.",
  },
];

const benefits = [
  {
    title: "Early-Stage Fundraising",
    description:
      "IGOs enable gaming startups to raise capital at early stages while building a loyal player-investor community.",
    icon: sIcon1,
  },
  {
    title: "Community Ownership",
    description:
      "Players become stakeholders, fostering long-term engagement and ecosystem growth.",
    icon: sIcon2,
  },
  {
    title: "Decentralized Fund Distribution",
    description:
      "Smart contracts ensure transparent and automated allocation of funds.",
    icon: sIcon3,
  },
  {
    title: "Global Accessibility",
    description:
      "Blockchain-powered IGOs allow global participation without traditional barriers.",
    icon: sIcon4,
  },
  {
    title: "Enhanced Liquidity",
    description:
      "Tokens launched through IGOs can be listed on exchanges, improving liquidity.",
    icon: sIcon5,
  },
  {
    title: "Trust & Transparency",
    description:
      "Immutable blockchain records enhance investor confidence and project credibility.",
    icon: sIcon6,
  },
];

const faqs = [
  {
    q: "What is an Initial Game Offering (IGO)?",
    a: "An Initial Game Offering is a fundraising model where blockchain-based gaming projects raise capital by selling game tokens to early supporters.",
  },
  {
    q: "How is IGO different from ICO or IDO?",
    a: "IGOs are focused on GameFi projects, offering in-game utility tokens rather than generic crypto assets.",
  },
  {
    q: "Which blockchains support IGO development?",
    a: "IGOs can be built on Ethereum, Binance Smart Chain, Polygon, Solana, and other EVM-compatible networks.",
  },
  {
    q: "Do you provide post-launch support?",
    a: "Yes. We offer ongoing maintenance, security upgrades, and feature enhancements after launch.",
  },
];

// ------------------------------------
// PAGE COMPONENT
// ------------------------------------

export default function InitialGameOffering() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Initial Game Offering (IGO)"
        pagesub="Launch, fund, and scale your GameFi project"
      />

      {/* ================= HERO ================= */}
      <HeroSection
        title={
          <>
            Power Your GameFi Launch with{" "}
            <span className="gradient-text">Initial Game Offering</span>
          </>
        }
        subtitle={`Initial Game Offerings help blockchain games raise capital, build communities,
and distribute tokens transparently. We design secure and scalable IGO platforms
tailored for next-generation gaming ecosystems.`}
        buttonText="Launch Your IGO"
        buttonLink="/contact"
        image={img13}
        imageAlt="Initial Game Offering Development"
      />

      {/* ================= THEORY ================= */}
      <TheorySection
        title="Understanding Initial Game Offering (IGO)"
        image={img14}
        paragraphs={[
          "An Initial Game Offering (IGO) is a modern fundraising approach designed specifically for blockchain-powered gaming projects. It allows game developers to raise capital by offering early access to in-game tokens, assets, or governance rights to investors and players. Unlike traditional fundraising models, IGOs directly connect the gaming ecosystem with its community, enabling users to become stakeholders from the very beginning.",
          "IGOs are a cornerstone of the GameFi ecosystem, blending decentralized finance with immersive gameplay. By leveraging smart contracts, IGOs ensure transparent token distribution, automated vesting schedules, and secure fund management. This model not only accelerates funding but also fosters long-term engagement by aligning player incentives with project growth.",
        ]}
      />

      {/* ================= SERVICES ================= */}
      <ServiceCardsSection
        title="Our Initial Game Offering Services"
        cards={serviceCards}
      />

      {/* ================= BENEFITS ================= */}
      <Benefit title="Benefits of Initial Game Offering" benefits={benefits} />

      {/* ================= KEY FEATURES ================= */}
      <KeyFeaturesSection
        title="Key Features of IGO Platforms"
        subtitle="A secure and scalable infrastructure built for GameFi fundraising."
        features={[
          {
            icon: sIcon1,
            title: "Token Sale Management",
            description:
              "Configurable token sales with whitelist, tier-based access, and caps.",
          },
          {
            icon: sIcon2,
            title: "Smart Contract Automation",
            description:
              "Automated token distribution, vesting schedules, and liquidity locking.",
          },
          {
            icon: sIcon3,
            title: "Multi-Chain Support",
            description:
              "Deploy IGOs across Ethereum, BSC, Polygon, and other networks.",
          },
          {
            icon: sIcon4,
            title: "Investor Dashboard",
            description:
              "Real-time tracking of investments, allocations, and token claims.",
          },
          {
            icon: sIcon5,
            title: "Security & Auditing",
            description:
              "Advanced security layers and audit-ready smart contracts.",
          },
          {
            icon: sIcon6,
            title: "Scalable Architecture",
            description:
              "Built to handle high traffic during token launches.",
          },
        ]}
      />

      {/* ================= WHY CHOOSE US ================= */}
      <WhyChooseUsSection
        items={[
          "Deep Expertise in GameFi & Web3",
          "Secure & Scalable IGO Architecture",
          "End-to-End Launch & Support",
        ]}
      />

      {/* ================= FAQ ================= */}
      <FaqSection faqs={faqs} />

      {/* ================= CTA ================= */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
